module.exports = __webpack_public_path__ + "static/broker-img-b792925919b8da24ac01f8f9f93192dd.png";